import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcbf3c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user_con" }
const _hoisted_2 = { class: "right_con" }
const _hoisted_3 = { style: {"margin":"0"} }
const _hoisted_4 = { class: "sub_title" }
const _hoisted_5 = { class: "demo" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "header" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "成交订单（笔）", -1))
const _hoisted_9 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_11 = { class: "num" }
const _hoisted_12 = { style: {"padding-left":"20px"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_14 = { style: {"font-size":"20px"} }
const _hoisted_15 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_17 = { style: {"font-size":"20px"} }
const _hoisted_18 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_20 = { style: {"font-size":"20px"} }
const _hoisted_21 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("累计成交订单：")
const _hoisted_23 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { class: "header" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "营业额（元）", -1))
const _hoisted_27 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_29 = { class: "num" }
const _hoisted_30 = { style: {"padding-left":"20px"} }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_32 = { style: {"font-size":"20px"} }
const _hoisted_33 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_35 = { style: {"font-size":"20px"} }
const _hoisted_36 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_38 = { style: {"font-size":"20px"} }
const _hoisted_39 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("累计营业额：")
const _hoisted_41 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_42 = { class: "item" }
const _hoisted_43 = { class: "header" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "新增会员（人）", -1))
const _hoisted_45 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_47 = { class: "num" }
const _hoisted_48 = { style: {"padding-left":"20px"} }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_50 = { style: {"font-size":"20px"} }
const _hoisted_51 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_53 = { style: {"font-size":"20px"} }
const _hoisted_54 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_56 = { style: {"font-size":"20px"} }
const _hoisted_57 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("会员人数：")
const _hoisted_59 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_60 = { class: "item" }
const _hoisted_61 = { class: "header" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "会员访问量（人）", -1))
const _hoisted_63 = { style: {"float":"right","margin-top":"-35px","margin-right":"20px"} }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("今日")
const _hoisted_65 = { class: "num" }
const _hoisted_66 = { style: {"padding-left":"20px"} }
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 昨日：")
const _hoisted_68 = { style: {"font-size":"20px"} }
const _hoisted_69 = {
  key: 0,
  style: {"margin-left":"50px","color":"red"}
}
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" 升：")
const _hoisted_71 = { style: {"font-size":"20px"} }
const _hoisted_72 = {
  key: 1,
  style: {"margin-left":"50px","color":"green"}
}
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 降：")
const _hoisted_74 = { style: {"font-size":"20px"} }
const _hoisted_75 = { style: {"padding-left":"20px","margin-top":"10px"} }
const _hoisted_76 = /*#__PURE__*/_createTextVNode("会员访问量：")
const _hoisted_77 = { style: {"font-size":"20px","float":"right","margin-right":"30px"} }
const _hoisted_78 = {
  key: 0,
  id: "mycharts",
  ref: "myRef",
  class: "chart-box",
  style: {"width":"100%","height":"450px"}
}
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = ["src"]
const _hoisted_82 = { style: {"margin-left":"10px"} }
const _hoisted_83 = {
  key: 0,
  id: "mycharts2",
  ref: "myRef2",
  class: "chart-box2",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = ["src"]
const _hoisted_87 = { style: {"margin-left":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_countTo = _resolveComponent("countTo")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { class: "home" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_avatar, {
            size: 70,
            style: {"backgroundColor":"#87d068"}
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_UserOutlined)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, "欢迎进入" + _toDisplayString(_ctx.appTitle) + "后台管理，祝你开心每一天！", 1),
            _createElementVNode("div", _hoisted_4, "更新时间" + _toDisplayString(_ctx.updata_time), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.order_num.today,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.order_num.yesterday), 1),
              (_ctx.order_num.change_add>0 || _ctx.order_num.change_add==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.order_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order_num.change_add<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.order_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.order_num.all_num), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.order_price.today,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", null, [
              _hoisted_31,
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.order_price.yesterday), 1),
              (_ctx.order_price.change_add>0 || _ctx.order_price.change_add==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.order_price.change_add), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order_price.change_add<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.order_price.change_add), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.order_price.all_price), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_46
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.add_user_num.today,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", null, [
              _hoisted_49,
              _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.add_user_num.yesterday), 1),
              (_ctx.add_user_num.change_add>0 || _ctx.add_user_num.change_add==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.add_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.add_user_num.change_add<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.add_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.add_user_num.all_num), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _hoisted_62,
          _createElementVNode("div", _hoisted_63, [
            _createVNode(_component_a_tag, { color: "blue" }, {
              default: _withCtx(() => [
                _hoisted_64
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.visit_user_num.today,
              duration: 3000
            }, null, 8, ["endVal"])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", null, [
              _hoisted_67,
              _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.visit_user_num.yesterday), 1),
              (_ctx.visit_user_num.change_add>0 || _ctx.visit_user_num.change_add==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                    _hoisted_70,
                    _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.visit_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.visit_user_num.change_add<0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.visit_user_num.change_add), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.visit_user_num.all_num), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_a_card, {
      title: "近30天营业额",
      style: {"margin-top":"20px","height":"600px","width":"70%"}
    }, {
      default: _withCtx(() => [
        (_ctx.article_sum !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, null, 512))
          : _createCommentVNode("", true),
        (_ctx.article_sum == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
              _createVNode(_component_a_empty, { style: {"padding-top":"40px"} })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      title: "销冠商家(前五名)",
      style: {"margin-top":"-600px","width":"28%","margin-left":"72%","height":"600px","float":"right"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          columns: _ctx.columns,
          "data-source": _ctx.shopList,
          pagination: false
        }, {
          bodyCell: _withCtx(({ column, text, record,index }) => [
            (column.key === 'shop_id')
              ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(index+1), 1))
              : _createCommentVNode("", true),
            (column.key === 'name')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("img", {
                    style: {"width":"40px","height":"40px"},
                    src: record.logo
                  }, null, 8, _hoisted_81),
                  _createElementVNode("span", _hoisted_82, _toDisplayString(record.name), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      title: "近30天会员访问量（人）",
      style: {"margin-top":"20px","height":"400px","width":"70%"}
    }, {
      default: _withCtx(() => [
        (_ctx.course_sum !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_83, null, 512))
          : _createCommentVNode("", true),
        (_ctx.course_sum == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
              _createVNode(_component_a_empty, { style: {"padding-top":"40px"} })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      title: "人气商家(前五名)",
      style: {"margin-top":"-400px","width":"28%","margin-left":"72%","float":"right"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          columns: _ctx.columns2,
          "data-source": _ctx.shopList2,
          pagination: false
        }, {
          bodyCell: _withCtx(({ column, text, record,index }) => [
            (column.key === 'shop_id')
              ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(index+1), 1))
              : _createCommentVNode("", true),
            (column.key === 'name')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("img", {
                    style: {"width":"40px","height":"40px"},
                    src: record.logo
                  }, null, 8, _hoisted_86),
                  _createElementVNode("span", _hoisted_87, _toDisplayString(record.name), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source"])
      ]),
      _: 1
    })
  ]))
}